import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';

import './css/index.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import App from './components/App';
import Firebase, { FirebaseContext } from './components/Firebase';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-5V5X9HZ'
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
	<FirebaseContext.Provider value={new Firebase()}>
		<App />
	</FirebaseContext.Provider>,
	document.getElementById('root')
);

serviceWorkerRegistration.register();
reportWebVitals();